import { fontSize, theme } from '@noths/polaris-client-ribbons-base';
import { inset, shadowDown } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var spacing = theme.spacing,
  text = theme.text;
export var header = /*#__PURE__*/css(["position:relative;z-index:1;display:flex;align-items:center;padding:", ";", ""], inset(spacing.xl), shadowDown);
export var title = /*#__PURE__*/css(["", " margin:0;"], fontSize(text.HEADING.SM));
export var closeBtn = /*#__PURE__*/css(["margin-left:auto;"]);